import React, { useEffect, useState } from 'react'
import CMS from '../../components/cms/CMS'
import PageBanner from '../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import CMSTable from '../../components/general/CMSTable'
import { useNavigate } from 'react-router-dom'
import CrudSocialMedia from './CrudSocialMedia'
import { columns } from '../../utilities/columns/socialMediaColumns'
import { fetchSocialMediaGetAll } from '../../redux/slices/socialMediaGetAllSlice'
import { fetchSocialMediaDelete } from '../../redux/slices/socialMediaDeleteSlice'

const SocialMediaPage = () => {
    const [modal, setModal] = useState(false)
    const [changed, setChanged] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const [loading, setLoading] = useState(false);
    const socialMedias = useSelector((state) => state.socialMediaGetAll.data)
    const lang = useSelector((state) => state.lang.lang)
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigation = useNavigate()

    const getData = async () => {
        setLoading(true);
        await dispatch(fetchSocialMediaGetAll())
        setChanged(false)
        setLoading(false);
    }

    const deleteData = async (id) => {
        await dispatch(fetchSocialMediaDelete({ id: id }))
        getData()
    }

    useEffect(() => { getData() }, [dispatch, changed])

    return (
        <CMS>
            <PageBanner
                modal={modal}
                setModal={setModal}
                title={t("social_media_management")}
                description={t("social_media_desc")}
                buttonText={t("add_social_media")}
            />

            <CMSTable
                columns={columns({
                    t: t,
                    modal: modal,
                    setModal: setModal,
                    lang: lang,
                    deleteData: deleteData,
                    navigation: navigation,
                    setSelectedItem: setSelectedItem
                })}
                data={socialMedias}
                loading={loading}
            />

            <CrudSocialMedia
                showMenu={modal}
                setShowMenu={setModal}
                setChanged={setChanged}
                setSelectedItem={setSelectedItem}
                selectedItem={selectedItem}
                t={t}
            />
        </CMS>
    )
}

export default SocialMediaPage
